import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import colors from 'aria-viewer/tour/constants/style/colors'
import Icon from 'aria-viewer/tour/components/icon'
import { MEDIA_TYPES, MEDIA_SIZES } from 'aria-viewer/tour/constants'

const defaultStyle = {
    text: {
        position: 'absolute',
        right: '14px',
        bottom: '16px',
        fontSize: '1.05em',
        fontWeight: 400,
        color: colors.white,
        margin: 0,
        zIndex: 1,
    },

    icon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '52px',
        height: '52px',
        zIndex: 5,
    },

    toBottom: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: '45px',
        borderRadius: '2.7px',
        backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.67))',
        zIndex: 2,
    },

    OneFourtyFiveDeg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'linear-gradient(145deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.66))',
        zIndex: 2,
    },

    title: {
        position: 'absolute',
        left: '15px',
        fontSize: '1.05em',
        fontWeight: 400,
        color: colors.white,
        margin: 0,
        zIndex: 3,
        bottom: '16px',
        maxWidth: '256px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}

const is360 = playback_type => {
    return playback_type == '360'
}

const getPanorama = text => {
    return <p style={Object.assign({}, defaultStyle.text, text)}>360</p>
}

const getVideo = icon => {
    return (
        <div style={Object.assign({}, defaultStyle.icon, icon)}>
            <Icon icon="play_empty" />
        </div>
    )
}

const getTitle = (showTitle, title, titleStyle) => {
    if (showTitle) {
        return <p style={Object.assign({}, defaultStyle.title, titleStyle)}>{title}</p>
    }
    return null
}

const wrapStyle = (elem, style) => {
    return (
        <div>
            {elem}
            <div style={style} />
        </div>
    )
}

const getSupplementalMedia = ({ mediaType, playback_type }, icon, text) => {
    let supplementalMediaType = null

    if (mediaType == MEDIA_TYPES.panorama) {
        supplementalMediaType = getPanorama(text)
    } else if (mediaType == MEDIA_TYPES.video && is360(playback_type)) {
        supplementalMediaType = (
            <div>
                {getPanorama(text)}

                {getVideo(icon)}
            </div>
        )
    } else if (mediaType == MEDIA_TYPES.video) {
        supplementalMediaType = getVideo(icon)
    }

    return supplementalMediaType
}

class MediaThumbComponent extends PureComponent {
    static propTypes = {
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        media: PropTypes.object.isRequired,
        size: PropTypes.oneOf(Object.values(MEDIA_SIZES)), // thumb, tiny, small, medium, large
        round: PropTypes.number,
        gradient: PropTypes.oneOf(['bottom', 'diagonal', false]), // false means no gradient
        style: PropTypes.object,
        aspect: PropTypes.string,
    }

    static defaultProps = {
        style: {},
    }

    constructor(props) {
        super(props)

        this.handleOnClick = this.handleOnClick.bind(this)
    }

    handleOnClick(e) {
        const { onClick, media } = this.props

        onClick && onClick(e, media)
    }

    render() {
        const {
            width,
            height,
            media,
            size,
            round,
            gradient,
            aspect,
            style,
            showTitle,
            showOverlay,
            thumbStyle,
        } = this.props

        let supplementalMedia = showOverlay ? getSupplementalMedia(media, style.icon, style.text) : null

        if (gradient == 'bottom') {
            supplementalMedia = wrapStyle(supplementalMedia, defaultStyle.toBottom)
        } else if (gradient == 'diagonal') {
            supplementalMedia = wrapStyle(supplementalMedia, defaultStyle.OneFourtyFiveDeg)
        }

        let title = showOverlay ? getTitle(showTitle, media.title, style.title) : null
        const url = size === MEDIA_SIZES.medium ? media.urls.medium : media.urls.tiny
        const divStyle = {
            width,
            height,
            backgroundImage: `url("${url}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            borderRadius: round,
        }

        return (
            <div onClick={this.handleOnClick} style={Object.assign({}, divStyle, thumbStyle)}>
                {title}
                {supplementalMedia}
            </div>
        )
    }
}

export default MediaThumbComponent
